// list-style-type sets the toolbar list buttons toggle / detect against.
// Shared by PlateToolbar and FloatingToolbar so the bulleted-vs-numbered
// classification stays in sync across both toolbars.
export const BULLETED_STYLES = ['disc', 'circle', 'square'];
export const NUMBERED_STYLES = ['decimal', 'decimal-leading-zero', 'decimal-legal', 'lower-alpha', 'upper-alpha', 'lower-roman', 'upper-roman'];
